module.exports = __webpack_public_path__ + "static/media/Reinvent.a94a7680.jpeg";